// extracted by mini-css-extract-plugin
module.exports = {"accordian-toggle":"FAQAccordionList_accordian-toggle__9ZKlX","card":"FAQAccordionList_card__zSrvc"};